import { Controller } from "stimulus";
import { cardView, parsePayload, mountPoint } from "../../training_grooming_calendar/hover_card";
import { placeAtPointer } from "../../training_grooming_calendar/pointer";
import { placePopover, visibleViewport } from "../../training_grooming_calendar/popover";
import { openOverlay, closeOverlay } from "../../training_grooming_calendar/overlay";

const DELAY = 120;

export default class extends Controller {
  static targets = ["container", "template", "payload"];

  show(event) {
    if (this.mobile()) return;
    const anchor = event.currentTarget;
    this.pointer = event.type === "mouseenter" ? { x: event.clientX, y: event.clientY } : null;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.render(anchor), this.pointer ? DELAY : 0);
  }

  move(event) {
    if (!this.pointer) return;
    this.pointer = { x: event.clientX, y: event.clientY };
    if (this.card) this.placeAtPointer();
  }

  hide() {
    clearTimeout(this.timer);
    this.pointer = null;
    if (this.card && !this.sheet) this.removeCard();
  }

  open(event) {
    if (!this.mobile()) return;
    event.preventDefault();
    const anchor = event.currentTarget;
    const card = this.build(anchor.dataset.bookingId);
    if (!card) return;
    this.removeCard();
    closeOverlay({ restoreFocus: false });
    this.sheet = true;
    this.card = card;
    mountPoint(this.containerTarget).appendChild(card);
    openOverlay({ element: card, anchor, root: this.element, sheet: true, onClose: () => this.removeCard() });
    const close = card.querySelector(".tg-card-close");
    if (close) close.focus({ preventScroll: true });
  }

  close() {
    closeOverlay();
  }

  reset() {
    clearTimeout(this.timer);
    this.cards = null;
    this.removeCard();
  }

  render(anchor) {
    if (!anchor.isConnected) return;
    const card = this.build(anchor.dataset.bookingId);
    if (!card) return;
    this.removeCard();
    this.card = card;
    card.setAttribute("role", "tooltip");
    card.classList.add("tg-card-floating");
    this.containerTarget.appendChild(card);
    if (this.pointer) {
      this.placeAtPointer();
    } else {
      const container = this.containerTarget.getBoundingClientRect();
      const spot = placePopover({ anchor: anchor.getBoundingClientRect(), container, viewport: visibleViewport(), width: card.offsetWidth, height: card.offsetHeight });
      card.style.left = `${spot.left}px`;
      card.style.top = `${spot.top}px`;
    }
  }

  build(id) {
    if (!this.hasTemplateTarget) return null;
    this.cards = this.cards || parsePayload(this.hasPayloadTarget ? this.payloadTarget.textContent : "");
    const data = this.cards[id];
    if (!data) return null;
    const view = cardView(data);
    const card = this.templateTarget.content.firstElementChild.cloneNode(true);
    card.classList.add(...view.classes);
    if (view.color) card.style.setProperty("--tg-tone", view.color);
    if (view.tint) card.style.setProperty("--tg-tone-bg", view.tint);
    card.setAttribute("aria-label", view.label);
    Object.entries(view.slots).forEach(([slot, text]) => {
      card.querySelector(`[data-slot="${slot}"]`).textContent = text;
    });
    const rows = card.querySelector('[data-slot="rows"]');
    view.rows.forEach(([label, value]) => {
      const term = document.createElement("span");
      term.className = "tg-card-key";
      term.textContent = label;
      const detail = document.createElement("span");
      detail.className = "tg-card-value";
      detail.textContent = value;
      rows.append(term, detail);
    });
    card.querySelector('[data-slot="link"]').href = view.href;
    return card;
  }

  placeAtPointer() {
    const container = this.containerTarget.getBoundingClientRect();
    const spot = placeAtPointer({ x: this.pointer.x, y: this.pointer.y, width: this.card.offsetWidth, height: this.card.offsetHeight, viewport: { width: window.innerWidth, height: window.innerHeight, top: visibleViewport().top } });
    this.card.style.left = `${spot.left - container.left}px`;
    this.card.style.top = `${spot.top - container.top}px`;
  }

  removeCard() {
    if (this.card) this.card.remove();
    this.card = null;
    this.sheet = false;
  }

  mobile() {
    return !!this.containerTarget.querySelector(".tg-mobile");
  }
}
